const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/zgks/eCheckin/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        einholenInfo: 'Einholen von Informationen',
        einholenInfo1:
            'Das Demospital Züri-West möchte bei den vorbehandelnden Ärztinnen und Ärzten medizinische Informationen einholen können.',
        einholenInfo2:
            'Sind Sie damit einverstanden und entbinden Sie die vorbehandelnden Ärzte von ihrer Schweigepflicht?',
        einwArzt: 'Einweisender Arzt',
        arztType: 'Durch welchen Arzt erfolgte die Zuweisung ins Spital?',
        andereArzt: 'Anderer externer Arzt',
        selbstEinweisung: 'Selbsteinweisung',
        zusatz: 'Zusatz',
        zusatzHelpText: 'Praxisname, Gemeinschaftspraxen, Spitäler, etc.',
        hausArzt: 'Hausarzt',
        keinHausarzt: 'Ich habe keinen Hausarzt',
        bezEhepartner: 'Ehepartner',
        bezElternteil: 'Elternteil',
        bezGeschwister: 'Geschwister',
        bezLebenspartner: 'Lebenspartner',
        kontakt: 'Kontaktperson',
        keineAngaben: 'Ich möchte keine Angaben zu Angehörigen machen',
        anrede: 'Anrede',
        beziehung: 'Beziehung',
        patInfo: 'Patienteninformationen',
        pleaseReadAndConfirm:
            'Bitte lesen Sie folgende Informationen. Sie müssen bestätigen, dass Sie diese gelesen haben.',
        informationHeader:
            'Steht Ihnen ein ambulanter oder stationärer Spitalaufenthalt bevor? Wir haben für Sie alle wichtigen Informationen zusammengestellt.',
        questionForMoreInformation:
            'Haben Sie noch Fragen? Gerne stehen wir Ihnen für weitere Informationen zur Verfügung.',
        administrativeQuestion: 'Für administrative und organisatorische Fragen:',
        PatInfoConfirmation:
            'Ich bestätige, dass ich die Informationen verstanden und zustimmend zur Kenntnis genommen habe.',
        openingTimeWorkWeek: 'Montag bis Freitag: 8 bis 16 Uhr',
        openingTimeWeekend: 'Samstag, Sonntag sowie Feiertage hat die Aufnahme geschlossen.',
        checkliste: 'Checkliste bei Spitaleintritt',
        ambAufenthalt: 'AMBULANTER AUFENTHALT',
        statAufenthalt: 'STATIONÄRER AUFENTHALT',
        persAngaben: 'Persönliche Angaben',
        male: 'Männlich',
        female: 'Weiblich',
        ledig: 'Ledig',
        verheiratet: 'Verheiratet',
        geschieden: 'Geschieden',
        telLandline: 'Telefon Festnetz',
        dateOfBirth: 'Geburtsdatum',
        gender: 'Geschlecht',
        zivilstand: 'Zivilstand',
        language: 'Sprache',
        nationality: 'Nationalität',
        profession: 'Beruf',
        religion: 'Religion',
        hometown: 'Heimatort',
        ahv: 'AHV-Nr.',
        ahvHelpText: 'Geben Sie Ihre 13-stellige AHV-Nummer in dieses Feld ein.',
        versicherungLabel: 'Ver­sicherung',
        illness: 'Krankheit',
        accident: 'Unfall',
        medicalInsurance: 'Kranken­versicherung',
        accidentInsurance: 'Unfallversicherung',
        klasseAllg: 'Allgemein',
        klasseHalbprivat: 'Halbprivat',
        klassePrivat: 'Privat',
        zustVersicherung: 'Garantenart',
        arbeitgeber: 'Arbeitgeber',
        versicherungName: 'Name der Versicherung',
        versichertenNr: 'Versiche­rungs-Nr.',
        versichertenNrHelpText: 'Entspricht der Policen-Nr.',
        kartenNr: 'Karten-Nr.',
        schadenNr: 'Schaden-Nr.',
        klasse: 'Versicher.-Klasse',
        zusatzVersicherung: 'Zusatz­versicherung',
        zusatzVersicherungName: 'Name der Zusatz­versicherung',
        behandlungsgrund: 'Behandlungs­grund',
        unfallDatum: 'Unfalldatum',
        schadenNrNichtBekannt: 'nicht bekannt',
    },
    __RELATIVE_SOURCE_FILE__
);
